// 12/08/2022 NextJS/public-app complains when this is bundled
// Requires boolean to be aliased for some reason
import { boolean as bool, InferType, number, object, string } from 'yup';

import { addressSchema } from '../common/address.schema';
import { phoneNumberSchema } from '../common/phoneNumber.schema';

export const adminEditUserSchema = object({
  id: number().required(),
  firstName: string().required(),
  lastName: string().required(),
  email: string().email(),
  admin: bool(),
  phoneNumber: phoneNumberSchema.nullable(),
  birthDate: string().nullable(),
  primaryResidenceAddress: addressSchema.nullable(),
  mailingAddress: addressSchema.nullable(),
});

export type AdminEditUserSchema = InferType<typeof adminEditUserSchema>;
